import React, { Component } from 'react';
// import './Docs.css'
import { Card,  Typography, Divider, Button } from 'antd';
const { Title, Paragraph, Text } = Typography;

class Docs extends Component {

  render() {
    return (
      <div style={{display: 'flex', flexDirection: 'column'}}>
          <div>
            <br />
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center',}}>
              <Title>Getting Started</Title>
              <Paragraph><b>Requirements</b></Paragraph>
              <ol style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <li>You have images that have been classified by a ML algorathim</li>
                <li>You have saved the predictions and images to a server or database</li>
                <li>You have an API endpoint that can GET a list of Items that have been Classified</li>
                <li>You have an API endpoint that can GET the images for the Items above </li>
                <li>You have an API endpoint that can accept the data you want to Update / Save </li>
              </ol>
              <br />    
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center',}}>
                <h3>Connect Endpoints</h3>
                <img src="../../../endpoint1.png"/>
                <p>* This endpoint should return an Array of Objects</p>
                <Divider />
                <img src="../../../endpoint2.png"/>
                <p>* This endpoint should return the Image associated with the Object</p>
                <p>* Variables are pulled from the result array</p>
                <Divider />
                <img src="../../../endpoint3.png"/>
                <p>* This endpoint will be called when you change the prediction / label of an image</p>
              </div>
            </div>

            <br />
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <Button type="primary" onClick={() => this.props.showPage('settings')}>Add Endpoints</Button>
            </div>
            <br />
           
          </div>
        </div>
    );
  }
}


export default Docs;

